// Scripting for sliders or carousels (Baytek gutenblocks plugin includes a slider block that uses slick slider)
(function($){

	// Simple Slider Block using Slick.js
	$('.carousel-slider').slick({
		arrows: true,
		dots: true,
		slidesToScroll: 1,
		slidesToShow: 4,
		infinite: true,
		// variableWidth: true,
		draggable: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="far fa-chevron-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="far fa-chevron-right"></i></button>',
		responsive: [{
			breakpoint: 1600,
			settings: {
				slidesToShow: 3
			}
		},{
			breakpoint: 1000,
			settings: {
				slidesToShow: 2
			}
		},{
			breakpoint: 500,
			settings: {
				slidesToShow: 1
			}
		}]
	});

	// If you need multiple Slider Blocks on one page use this instead of above:
	///// 1. Create a Group Block with the class: carousel-wrapper
	///// 2. Add the Slider Block in this new Group
	///// 3. Below the Slider and in the same Group add the Buttons Block for the custom Arrows
	///// 4. Add 2 buttons:  1st will have '.left' class. 2nd will have '.right' class.
	// $('.carousel-wrapper .wp-block-group__inner-container .carousel-slider').each(function(){
	// 	var slickIndividual = $(this);
	// 	slickIndividual.slick({
	// 		slidesToShow: 3,
	// 		slidesToScroll: 1,
	// 		arrows: true,
	// 		dots: false,
	// 		nextArrow: slickIndividual.next().find('.right'),
	// 		prevArrow: slickIndividual.next().find('.left'),
	// 		draggable: true,
	// 		infinite: true,
	// 	  	responsive: [
	// 	  		{
	// 				breakpoint: 720,
	// 				settings: {
	// 					slidesToShow: 2
	// 				}
	// 			}
	// 		]
	// 	});
	// });

	/**
	 * Topic slider
	 */
	$('.topics-slider').each(function() {
		$(this).slick({
			arrows: true,
			dots: true,
			slidesToScroll: 1,
			slidesToShow: parseInt($(this).attr('data-slides')),
			// slidesToShow: 1,
			infinite: true,
			draggable: true,
			prevArrow: '<a class="topic-arrow slick-prev slick-arrow"><i class="far fa-angle-left"></i></a>',
			nextArrow: '<a class="topic-arrow slick-next slick-arrow"><i class="far fa-angle-right"></i></a>',
			appendArrows: $(this).prev().find('.topic-slider-control').first(),
			// variableWidth: true,
			responsive: [
				{
					breakpoint: 980,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 720,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	});

	$('.featured-section ').each(function() {
		$('.post-slider > .wp-block-group__inner-container', this).slick({
			arrows: true,
			dots: true,
			slidesToScroll: 1,
			slidesToShow: 3,
			infinite: true,
			draggable: true,
			prevArrow: '<a class="slick-prev slick-arrow"><i class="far fa-angle-left"></i></a>',
			nextArrow: '<a class="slick-next slick-arrow"><i class="far fa-angle-right"></i></a>',
			appendArrows: $(this).find('.slider-controls').first(),			
			responsive: [
				{
					breakpoint: 980,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]

		})
	});

	// Genesis Block - Tab Slider
	$('.wp-block-tab-slider').each(function() {
		$(this).slick({
			arrows: true,
			dots: false,
			slidesToScroll: 1,
			slidesToShow: 1,
			infinite: true,
			draggable: true,
			variableWidth: false,
			prevArrow: '<a class="slick-prev slick-arrow"><i class="far fa-angle-left"></i></a>',
			nextArrow: '<a class="slick-next slick-arrow"><i class="far fa-angle-right"></i></a>',
		})
	})
	$('.tab-slider-tabs').each(function () {
		$(this).slick({
			slidesToScroll: 1,
			variableWidth: false,
			asNavFor: '.wp-block-tab-slider',
			focusOnSelect: true,
			focusOnChange: true,
			accessibility: true
		});
	});
	$('.tab-slider-tabs .slick-slide').on('click', function (event) {
		$('.wp-block-tab-slider').slick('slickGoTo', $(this).data('slickIndex'));
		activeClass($('.wp-block-tab-slider .slick-active').data('slickIndex'));
	});
	$('.wp-block-tab-slider').on('click', function (event) {
		activeClass($('.wp-block-tab-slider .slick-active').data('slickIndex'));
	});
	// add/remove the .active on tabs
	function activeClass(slideIndex) {
		$('.tab-slider-tabs .slick-slide').removeClass('slick-current');
		$('.tab-slider-tabs .slick-slide[data-slick-index=' + slideIndex + ']').addClass('slick-current');
		if (window.innerWidth < 720) { // scroll to top of slider on mobile widths
			$('html, body').animate({
				scrollTop: $(".wp-block-tab-slider").offset().top
			}, 2000);
		};
	}

	/**
	 * Accessibility: Slick assigns role="tabpanel" and aria-describedby to every
	 * slide. That role is not permitted on the elements used as slides here
	 * (e.g. anchor tags in the hero), which fails WCAG/axe "aria-allowed-role".
	 * Strip those attributes after init and on every relayout (resize /
	 * responsive breakpoint), since Slick re-applies them on reinit.
	 */
	function stripSlickSlideRoles(slider) {
		$(slider).find('.slick-slide').removeAttr('role').removeAttr('aria-describedby');
	}

	$('.slick-slider').each(function () {
		stripSlickSlideRoles(this);
	});

	$(document).on('init setPosition breakpoint', '.slick-slider', function () {
		stripSlickSlideRoles(this);
	});

})(jQuery);